<div class="w-100 d-flex align-items-center justify-content-center bg-white" *ngIf="progress_spinner" style="min-height: 400px;">
  <span class="purpleLoader"></span>
</div>
<div *ngIf="!progress_spinner">
<div class="d-flex align-items-center justify-content-between mb-3">
  <div class="card-sub-heading">
    Update the transfer prescription status as
    {{ props.item.statusMessage }}?
  </div>
  <button mat-icon-button (click)="dialogRef.close()" type="button" [disabled]="isLoading">
    <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
  </button>
</div>
<form [formGroup]="form" (ngSubmit)="formSubmit()">
  <div class="row py-2">
    <div class="col-md-12">

      <mat-checkbox class="example-margin bold" (change)="onCheckChange($event)" formControlName="NotifyUsers">
        Notify Users
      </mat-checkbox>

      <div class="row p-3" *ngIf="form.value.NotifyUsers">
        <div class="col-md-12">
          <div class="d-flex row py-3">

            <ng-container formArrayName="NotifyUsersBy">
              <ng-container *ngFor="let item of notifyByArray.controls; let i = index">
                <ng-container [formGroupName]="i">
                  <div class="col-md-4">
                    <mat-checkbox [value]="item.value.id" formControlName="isChecked" [disabled]="item.value.disable">
                      {{ item.value.value }}
                    </mat-checkbox>
                  </div>
                </ng-container>
              </ng-container>

              <!-- <ng-container>
                <div class="col-md-4">
                  <mat-radio-group
                    class="d-flex flex-wor p-1"
                    formControlName="NotifyUsersBy"
                  >
                    <mat-radio-button value="2" checked class="p-1 mr-3">
                      Send SMS
                    </mat-radio-button>
                    <mat-radio-button value="3" class="p-1">
                      Send Chat Message
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
              </ng-container> -->
            </ng-container>
            <ng-container *ngIf="this.selectedStatus == 'transfer completed'">
                <div class="row mt-2">
                  <div class="col-md-12 px-0 mt-4">
                    <label>Status</label>
                    <mat-radio-group formControlName="filled_status" class="d-flex flex-row">
                      <mat-radio-button [value]="'1'" class="mr-3">Filled</mat-radio-button>
                      <mat-radio-button [value]="'0'">Not Filled</mat-radio-button>
                    </mat-radio-group>
                    <!-- <app-error-message [formName]="form" [fieldName]="'filled_status'" [type]="'group'">
                    </app-error-message> -->
                  </div>
                </div>
              </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="!isReasonLoaded && isReasonStatus">
    <div class="d-flex align-items-center justify-content-center">
      <span class="whiteLoader" style="width: 30px; height: 30px;"></span>
    </div>
  </ng-container>
  <ng-container *ngIf="isReasonLoaded">
    <div class="row mb-2">
      <div class="col-md-12" *ngIf="isReasonStatus">
        <label for="reasonList">Select Reason</label>
        <mat-select formControlName="reason_id" class="form-control w-100"
          placeholder="Select reason to {{ selectedStatus }}">
          <mat-option *ngFor="let item of reasonList" [value]="item.id">
            {{ item?.name }}
          </mat-option>
          <!-- <mat-option class="select-btn" (click)="openAddRasonDialog()">
          <div class="d-flex align-items-center">
            <span class="material-icons mr-2 add"> add </span> Add reason to
            {{ props.item.status }}
          </div>
        </mat-option> -->
        </mat-select>
        <app-error-message [formName]="form" [fieldName]="'reason_id'" [type]="'group'">
        </app-error-message>
      </div>
      <!--  <div class="col-md-12" *ngIf="isCourierStatus">
      <label for="courierList">Select courier</label>
      <mat-select
        formControlName="courier_id"
        class="form-control w-100"
        placeholder="Select courier to {{ props.item.status }}"
      >
        <mat-option *ngFor="let item of courierList" [value]="item.id">
          {{ item?.name }}
        </mat-option>
        <mat-option class="select-btn" (click)="openAddCourierDialog()">
          <div class="d-flex align-items-center">
            <span class="material-icons mr-2 add"> add </span> Add courier to
            {{ props.item.status }}
          </div>
        </mat-option>
      </mat-select>
      <app-error-message
        [formName]="form"
        [fieldName]="'courier_id'"
        [type]="'group'"
      >
      </app-error-message>
    </div> -->
    </div>
  </ng-container>
  <div class="row mb-2">
    <div class="col-md-12" *ngIf="isReasonStatus && showInternalNotes">
      <label for="reasonList">Notes</label>
      <textarea class="form-control height" formControlName="internal_notes"
        placeholder="Please enter notes for selected reason" rows="3"></textarea>
    </div>
  </div>
  <div class="row py-2">
    <div class="col-md-12">
      <!-- <div class="card-sub-heading grey">User Last Login</div>
      <div class="mt-2">Mon, Aug 16, 2021 6:27</div> -->
    </div>
  </div>
  <ng-container *ngIf="!isMessageLoaded && form.get('message')?.value != null">
    <div class="d-flex align-items-center justify-content-center">
      <span class="whiteLoader" style="width: 30px; height: 30px;"></span>
    </div>
  </ng-container>
  <ng-container *ngIf="isMessageLoaded && form.get('message')?.value != null && isPatientMessage"> 
    <div class="row py-4" *ngIf="isCustomMessageVisible() && this.form.value.NotifyUsers">
      <div class="col-md-12">
        <mat-checkbox class="example-margin" formControlName="custom_message" (change)="onCheckMessage($event)">Automated chat</mat-checkbox>
      </div>
    </div>
    <div class="row" *ngIf="form.get('custom_message')?.value == true">
      <div class="col-md-12">
        <div class="form-group">
          <textarea class="form-control height" formControlName="message" placeholder="Custom message enter here..."
            rows="3"></textarea>
          <mat-error class="ml-3" *ngIf="
            form.controls['message'].touched &&
            form.controls['message'].hasError('required')
          ">
            Message is required
          </mat-error>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="row mt-4">
    <div class="col-md-12 d-flex align-items-end justify-content-end">
      <button class="custom-btn" (click)="dialogRef.close()" type="button" [disabled]="isLoading">
        Cancel
      </button>
      <button class="custom-btn" type="submit" [disabled]="form.invalid || isLoading">
        {{ isLoading ? 'Confirming...' : 'Confirm' }}
      </button>
    </div>
  </div>
</form>
</div>
